module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAfCAYAAAAFkva3AAABY0lEQVRIiaXVPyuFYRjH8UcijiJew5H8GaSUQZIyKIPBYDCcklBegLIZDAaTshgsMsmiDMogSil5B4gIiYSIfHXVOfU4fnfOdbvqd+p56ny6n/vPdSdAP3AG3ACTQBIb+znlZ838B7vjd83FYuMCs1oAyryYZRr4EuCSB0w/2Ag/BbgClHsxy2gAXCsFVC+HgXcBbgCVXswyCLwJcAuo8mKFzfwiwB0g48UsPcCTAPeAWi9m6QIeBHgI1HsxS0fgpBwDLV7M0gZcC/AWaPZilibgQoCXQNaLWXoFZnXghbLAuYDs8xs9kM3LVWDOWj1z1p7vxMV1kl+YklezE7gX0BHQ4Nln3cCjgPaBOs8J6AOeBbQL1Kj/hKAB4FVA20B1aADq5VCgn216+9kI8CGgdaDir8VKP+QCLXvVewdMBW6nZe/tNBaAFmPuTdWn5j1IGituKbMxUAGzPWWn3kY4EQsByTctfY8LoRvyaQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/next.png
// module id = CBlF
// module chunks = 9